import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ReactComponent as ConservationIcon } from '../../assets/icons/conservation.svg';

import css from './FAQSectionConservation.module.css';
import { Container } from '../../components/Layout';

const FAQSectionConservation = () => {
  return (
    <Container>
      <div className={css.root}>
        <div className={css.iconContainer}>
          <ConservationIcon />
        </div>

        <h1 className={css.title}>
          <FormattedMessage id="FAQLandownersPage.conservation.title" />
        </h1>

        <p className={css.content}>
          <FormattedMessage id="FAQLandownersPage.conservation.body" />
        </p>
      </div>
    </Container>
  );
};

export default FAQSectionConservation;
